<template>
  <section class="social">
    <p>Follow us</p>
    <ul class="social-list">
      <li
        class="social__item"
        v-for="social in socials"
        :key="social.name"
        data-mouse
        data-mouse-attractionState="active"
        data-mouse-attraction="high"
        data-mouse-attractionVal="50"
        data-mouse-magnetism="10"
        data-hover-type="fadeout"
      >
        <a :href="social.url" rel="noopener" target="_blank" data-text>{{ social.abbr }}</a>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'social',

  data() {
    return {
      socials: [
        {
          name: 'Instagram',
          abbr: 'In',
          url: 'https://www.instagram.com/oneworldoneface/',
        },
        {
          name: 'Twitter',
          abbr: 'Tw',
          url: 'https://twitter.com/OneWorldOneFace',
        },
        {
          name: 'Facebook',
          abbr: 'Fb',
          url: 'https://www.facebook.com/oneworldoneface/',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.social {
  text-align: right;
  margin-top: 30px;

  p {
    display: inline-block;
    color: $color-dark-gray;
  }

  &-list {
    display: inline-block;
  }

  &__item {
    display: inline-block;
    position: relative;

    a {
      display: inline-block;
      width: 100%;
      padding: 10px;

      @at-root .pointerevents:not(.touchevents) &:hover,
      .no-pointerevents.no-touchevents &:hover {
        color: $color-link-hover;
      }

      @include mq(sm) {
        padding: 20px;
      }

      &:focus {
        outline: transparent;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Social.vue